import getDashboardTabIcon from '../helpers/getDashboardTabIcon';
import { TabBarMeta, TabButton, TabList } from '../styled';
import type { DashboardTabsProps } from './types';

const DashboardTabs = ({ items, activeTabId, onSelectTab, children }: DashboardTabsProps) => (
    <TabList role="tablist" aria-label="Dashboard sections">
        {items.map(item => {
            const isActive = item.tabId === activeTabId;
            const TabIcon = getDashboardTabIcon({ tabId: item.tabId });
            return (
                <TabButton
                    key={item.tabId}
                    type="button"
                    role="tab"
                    aria-selected={isActive}
                    id={`dashboard-tab-${item.tabId}`}
                    aria-controls={`dashboard-panel-${item.tabId}`}
                    $isActive={isActive}
                    onClick={() => {
                        onSelectTab({ tabId: item.tabId });
                    }}
                >
                    <TabIcon aria-hidden="true" />
                    {item.label}
                </TabButton>
            );
        })}
        <TabBarMeta>{children}</TabBarMeta>
    </TabList>
);

export default DashboardTabs;
